import React from 'react';
import { Flex, Modal, Typography, theme } from 'antd';
import { WarningFilled } from '@ant-design/icons';

import type Plan from './Plan';

type AlertTitleProps = {
  isDowngrading: boolean;
};

function AlertTitle({ isDowngrading }: AlertTitleProps) {
  const { token } = theme.useToken();
  return (
    <Flex gap="middle" align="center">
      <WarningFilled style={{ color: token.colorWarning }} />
      <Typography.Title level={4} style={{ margin: 0 }}>
        {isDowngrading ? 'Downgrading' : 'Upgrading'} plan
      </Typography.Title>
    </Flex>
  );
}

type InsufficientRendersDisclaimerProps = {
  newPlan?: Plan | null;
  onConfirm: () => void;
  onCancel: () => void;
  isDowngrading?: boolean;
};

function InsufficientRendersDisclaimer({
  newPlan,
  onConfirm,
  onCancel,
  isDowngrading = false,
}: InsufficientRendersDisclaimerProps) {
  return (
    <Modal
      title={<AlertTitle isDowngrading={isDowngrading} />}
      open={!!newPlan}
      onOk={onConfirm}
      okText={isDowngrading ? 'Schedule Downgrade Anyway' : 'Upgrade Plan'}
      okButtonProps={{
        danger: isDowngrading,
        type: 'primary',
      }}
      onCancel={onCancel}
    >
      {newPlan && (
        <Typography.Paragraph>
          <p>
            The &quot;{newPlan.name}&quot; plan <Typography.Text strong>contains fewer renders</Typography.Text> than
            your estimated usage.
          </p>
          <p>
            {isDowngrading ? 'When the scheduled downgrade takes effect, this plan' : 'Switching to this plan'} might
            lead to exceeding the render limit with a cost of {newPlan.addonCostInCents / 100} per 1000 additional
            renders.
          </p>
        </Typography.Paragraph>
      )}
    </Modal>
  );
}

export default InsufficientRendersDisclaimer;
